import { Modal, ModalBody, ModalHeader } from "shared/components/modal";
import { useSendCalendarInviteByActivityAdmin } from "./service";
import useNavigateWrapper from "shared/hooks/useNavigateWrapper";
import Icon from "assets/icons";
import React from "react";
import { useCopies } from "shared/hooks/useCopies";
import { useOutletContext } from "react-router-dom";
import { ApiActivityMeetingList } from "shared/types/ApiActivityMeetingList";
import { ParticipantName } from "shared/components/participantName";
import DateTimeHelper from "shared/utils/dateTimeHelper";
import NoDataFound from "shared/components/noDataFound";
import ModalCustomTitle from "shared/components/modalCustomTitle";
import { ModalSubTitleType } from "shared/components/modalCustomTitle/enum";
import SearchWrapper from "shared/components/searchWrapper";

export default function SendCalendarInviteToParticipants() {
  const service = useSendCalendarInviteByActivityAdmin();
  const context = useOutletContext<ApiActivityMeetingList | undefined>();

  const { navigateBack } = useNavigateWrapper();
  const copies = useCopies();

  return (
    <Modal className="sendCalendarInviteModal">
      <ModalHeader
        left={
          <ModalCustomTitle
            title={context?.name as string}
            subTitleType={ModalSubTitleType.LOCATION}
            subTitle={context?.location}
          />
        }
        onClose={() => {
          navigateBack();
        }}></ModalHeader>
      <ModalBody>
        <div className="manageParticipant--heading">
          <div className="manageParticipant--heading_time">
            <Icon.ClockIcon />{" "}
            {context?.time &&
              DateTimeHelper.formatDate({
                startDate: context?.time.timeFrom,
                endDate: context?.time.timeTo,
                timeZone: context?.time.timeZoneDisplayStr,
                option: {
                  showTime: true
                }
              })}
          </div>
          <div className="manageParticipant--heading_filters">
            <SearchWrapper
              appliedSearchText={service.searchText}
              searchChangeHandler={service.setSearchText}
              placeholder={copies.get("type.to.search")}
            />
          </div>
        </div>
        <React.Fragment>
          <div className="manageParticipantTable">
            <div className="materialListTable">
              {service.filteredParticipants?.length ? (
                <div className="materialListTable">
                  <ul className="materialListTable_header">
                    <li>
                      <div className="materialListTable_header_items matListTable_columns">
                        <div className="matListTable_col manageParticipant_col_srNo">#</div>
                        <div className="matListTable_col manageParticipant_col_name">{copies.get("participant")}</div>
                        <div className="matListTable_col manageParticipant_col_jobTitle">{copies.get("job.title")}</div>
                        <div className="matListTable_col manageParticipant_col_action">{copies.get("action")}</div>
                      </div>
                    </li>
                  </ul>
                  <ul className="materialListTable_body">
                    {service.filteredParticipants?.map((participant, index) => (
                      <li>
                        <div className="materialListTable_body_items matListTable_columns">
                          <div className="matListTable_col manageParticipant_col_srNo">{index + 1}</div>
                          <div className="matListTable_col manageParticipant_col_name">
                            <ParticipantName
                              firstName={participant.firstName}
                              lastName={participant.lastName}
                              accessRequirement={participant.accessRequirement}
                            />
                          </div>
                          <div className="matListTable_col manageParticipant_col_name">
                            {participant.jobTitle || copies.get("empty.cell")}
                          </div>
                          <div className="matListTable_col manageParticipant_col_action participant-action">
                            {service.trackedCalendarInvites.includes(participant.id) ? (
                              <span className="inviteSent">
                                <Icon.CalenderCheck />
                                {copies.get("associate.program.participant.notified")}
                              </span>
                            ) : (
                              <span
                                className="resentInviteButton"
                                onClick={() => service.handleSendCalendarInvite(participant.id)}
                                title={copies.get("associate.program.participant.notify")}>
                                <Icon.CalendarInvite /> {copies.get("associate.program.participant.notify")}
                              </span>
                            )}
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                  <div className="manageParticipant--footer resultCount">
                    <span>
                      {copies.get("results")}: {service.filteredParticipants?.length || 0}
                    </span>
                  </div>
                </div>
              ) : (
                <NoDataFound height="58vh" />
              )}
            </div>
          </div>
        </React.Fragment>
      </ModalBody>
    </Modal>
  );
}
